import { PROGRESS_START } from '../../mutation-types';
import stockApi from '../../../api/stock';
import transactionApi from '../../../api/transaction';
import profileApi from '../../../api/profile';
import dashboardApi from '../../../api/dashboard';
import statusApi from '../../../api/status';
import moment from 'moment'

const defaultState = () => ({
    stock: [],
    stockAktivasi: {},
    stockRo: {},
    stockTransaction: {},
    stokPengambilan: [],
    stokPengiriman: [],
    salesSummary: {
        results: '',
        year: '',
    },
    profile: {
        stockist_code: '-'
    },
    totalSales: [],
    status: {}
})

const state = defaultState();

const getters = {
    chartData() {
        let month = [
            ['Jan'],
            ['Feb'],
            ['Mar'],
            ['Apr'],
            ['Mei'],
            ['Jun'],
            ['Jul'],
            ['Agu'],
            ['Sep'],
            ['Okt'],
            ['Nov'],
            ['Des'],
        ]

        let title_chart = [];
        for (var i = 0; i < month.length; i++) {
            for (var j = 0; j < state.salesSummary.results.length; j++) {
                if (i == j) {
                    title_chart = ['Year'];
                    state.salesSummary.results[j].product.forEach(element => {

                        month[i].push(parseInt(element.total_sales))
                        title_chart.push(element.product_name + ' (' + element.product_code + ')');
                    });
                }
            }
        }
        month.unshift(title_chart);
        return month
    },

    serialChartData() {
        let serial = [
            ['Milagros Water'],
            ['Starterkit'],
            ['Water']
        ]
        serial[0].push(parseInt(state.stock.stock_ro))
        serial[1].push(parseInt(state.stock.stock_starterkit))
        serial[2].push(parseInt(state.stock.stock_starterkit))

        serial.unshift(['Stock', 'All Stock'])
        return serial
    },

    buyerChartData() {
        let product = [
            ['product code', 'Jumlah', { role: "style" }]
        ]
        let color = ['#3b2eb2', '#cd78db', '#a29bfe']
        state.totalSales.forEach((element, index) => {
            product.push([element.product_code, parseInt(element.total_sales), color[index]])
        });
        return product
    },

    statusInput() {
        if (state.status.length > 0) {
            return [
                [state.status[3].status, state.status[3].total],
                [state.status[4].status, state.status[4].total],
                [state.status[6].status, state.status[6].total],
                [state.status[7].status, state.status[7].total],
                [state.status[9].status, state.status[9].total],
            ]
        } else {
            return []
        }
    },
}

const mutations = {
    listStock(state, data, ) {
        state.stock = data;
    },

    listSerialAktivasi(state, data) {
        state.stockAktivasi = Object.assign({}, state.stockAktivasi, data);
    },

    listSerialRo(state, data) {
        state.stockRo = Object.assign({}, state.stockRo, data);
    },

    listTransaction(state, data) {
        state.stockTransaction = Object.assign({}, state.stockTransaction, data);
    },

    listPengambilan(state, data) {
        state.stokPengambilan = data;
    },

    listPengiriman(state, data) {
        state.stokPengiriman = data;
    },

    listProfile(state, data) {
        state.profile = Object.assign({}, state.profile, data);
    },

    listSalesSummary(state, data) {
        state.salesSummary = Object.assign({}, state.salesSummary, data);
    },

    listTotalSales(state, data) {
        state.totalSales = [...data];
    },

    listStatus(state, data) {
        state.status = Object.assign([], state.status, data);
    }
};

const actions = {
    getStatus({ commit }) {
        statusApi.getStatus().then(({ data: { data: { results } } }) => {
            commit('listStatus', results)
        })
    },

    getProfile({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        profileApi.getDataProfile().then(({ data: { data } }) => {
            commit('listProfile', data);
        });
    },

    getStock({ commit }) {
        commit(PROGRESS_START, null, { root: true });
        stockApi.getDataStock().then(({ data: { data: { data } } }) => {
            commit('listStock', data);
        })
    },

    getDataSerial({ commit }) {
        let datetime = moment().format('YYYY-MM-DD');

        stockApi.getDataStockSerial({
                'filter[0][value]': 0,
                'filter[0][field]': 'stock_product_type',
                'filter[0][comparison]': '=',
                'filter[0][type]': 'string',
                'filter[1][value]': datetime,
                'filter[1][field]': 'stock_product_stock_expired_datetime',
                'filter[1][comparison]': '>',
                'filter[1][type]': 'date',
                'filter[2][value]': '0',
                'filter[2][comparison]': '=',
                'filter[2][type]': 'string',
                'filter[2][field]': 'stock_serial_status',
                limit: 5
            })
            .then(({ data: { data: { results } } }) => {
                commit('listSerialAktivasi', results);
            })
        stockApi.getDataStockSerial({
                'filter[0][value]': 1,
                'filter[0][field]': 'stock_product_type',
                'filter[0][comparison]': '=',
                'filter[0][type]': 'string',
                'filter[1][value]': datetime,
                'filter[1][field]': 'stock_product_stock_expired_datetime',
                'filter[1][comparison]': '>',
                'filter[1][type]': 'date',
                'filter[2][value]': '0',
                'filter[2][comparison]': '=',
                'filter[2][type]': 'string',
                'filter[2][field]': 'stock_serial_status',
                limit: 5
            })
            .then(({ data: { data: { results } } }) => {
                commit('listSerialRo', results);
            })
    },

    getTransaction({ commit }) {
        transactionApi.list({ limit: 3, sort: 'trx_datetime', dir: 'DESC' }).then(({ data: { data: { results } } }) => {
            commit('listTransaction', results);
        })
    },

    dataPickup({ commit }) {
        dashboardApi.getpickupToday().then(({ data: { data: { results } } }) => {
            if (results.length > 0) {
                commit('listPengambilan', results);
            } else {
                commit('listPengambilan', 'error');
            }
        })
    },

    dataShipping({ commit }) {
        dashboardApi.getShipping().then(({ data: { data: { results } } }) => {
            if (results.length > 0) {
                commit('listPengiriman', results);
            } else {
                commit('listPengiriman', 'error');
            }
        })
    },

    getSalesSummary({ commit }) {
        dashboardApi.getSalesSummary().then(({ data: { data } }) => {
            commit('listSalesSummary', data);
        })
    },

    getTotalSales({ commit }) {
        dashboardApi.getTotalSales().then(({ data: { data: { results } } }) => {
            commit('listTotalSales', results);
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}